import { httpRequest } from "@services/http";
import type { AggregateVersion } from "@models/aggregateVersion.model";

export class CommandListOrgUserVersions {
  async run(orgId: number): Promise<AggregateVersion[]> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/permissions/organizations/${orgId}/users/versions/`;
    try {
      return await httpRequest<AggregateVersion[]>(url, { method: "GET" });
    } catch (error) {
      console.error("Error loading organization user history:", error);
      throw error;
    }
  }
}
